'use client';

import { useAtomValue } from 'jotai';
import { CtaComponent } from '@sapientpro/sapientpro-data-models';
import clientDeviceSize, { ScreenSize } from '../../store/deviceScreenSize';
import styles from './CalculatorCTA.module.scss';

const CTAImage = ({ image, media }: { image: CtaComponent['smallResolutionImage']; media: CtaComponent['media'] }) => {
  const deviceSize = useAtomValue(clientDeviceSize);
  const isMobile = (deviceSize < ScreenSize.DESKTOP_SMALL);

  return (
    isMobile && image ? (
      <img
        src={image?.url}
        alt={image?.caption ?? 'CTA'}
        className={styles.calculatorCTA__image}
        loading='lazy'
      />
    ) : (
      <img
        src={media.url}
        alt={media.caption ?? 'CTA'}
        className={styles.calculatorCTA__image}
        loading='lazy'
      />
    )
  );
};

export default CTAImage;
